import { render, staticRenderFns } from "./EditCustomerDialog.vue?vue&type=template&id=4c2364ab"
import script from "./EditCustomerDialog.vue?vue&type=script&lang=js"
export * from "./EditCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports